export default __webpack_public_path__ + "f08606475512ad96518fd8aa79aac102.png";